//文字衔接横向滚动
<template>
    <div class="marquee-content" :class="styleType">
        <div class="box">
            <span class="text1" :style="{left: `${scrollPosition}px`}" ref="text">{{text}}</span>
            <span class="text2" :style="{left: `${scrollPosition2}px`}">{{text}}</span>
        </div>
    </div>

</template>

<script>
    export default {
        name: "MyMarquee",
        props: {
            text: {
                type: String,
                default: ''
            },
            scrollToStart: {
                type: Number,
                default: -1
            },
            styleType: {
                type: String,
                default: 'normal',
            }
        },
        data() {
            return {
                width: 0,
                scrollPosition: 0,
                scrollPosition2: 0,
                timer: null,
            }
        },
        watch: {
            text(value, oldValue) {
                // this.width = 100
                // this.scrollPosition = 0
                // this.scrollPosition2 = this.width
                // setTimeout(()=>{
                //     this.width = this.$refs.text.clientWidth / 37.5
                //     this.scrollPosition2 = this.width
                // }, 10)
                this.$nextTick(()=>{
                    this.scrollPosition = 0
                    this.width = this.$refs.text.clientWidth
                    this.scrollPosition2 = this.width
                })
            }
        },
        mounted() {
            this.width = this.$refs.text.clientWidth
            this.scrollPosition2 = this.width
            this.timer = setInterval(()=>{
                this.scrollPosition = this.scrollPosition <= -this.width ? 0 : this.scrollPosition - .5
                this.scrollPosition2 = this.scrollPosition2 <= 0 ?this.width : this.scrollPosition2 - .5
            }, 10)
        },
        destroyed() {
            clearInterval(this.timer)
        },
        methods: {

        }
    }
</script>

<style scoped lang="less">
    .normal{
        font-size: 0.32rem;
        height: .34rem;
        line-height: .34rem;
    }
    .title{
        font-size: 0.43rem;
        height: .43rem;
        line-height: .45rem;
        height: .45rem;
        font-weight: 600;
        font-family: PingFangSC-Medium, PingFang SC;
    }
    .marquee-content{
        width: 100%;
        margin-bottom: .16rem;
        color: #333333;
        overflow: hidden;
        .box{
            height: 100%;
            position: relative;
            .text1{
                white-space: nowrap;
                position: absolute;
                display: inline;
                padding: 0 .5rem;
            }
            .text2{
                white-space: nowrap;
                position: absolute;
                display: inline;
                padding: 0 .5rem;
            }
        }
    }

</style>
